import React, { Suspense } from 'react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Card } from '../../../components/ui/Card';
import { Skeleton } from '../../../components/ui/Skeleton';
import type { PeriodOption } from '@repo/shared-dashboard';

const DashboardCharts = React.lazy(() => import('../../../routes/_auth/components/DashboardCharts'));

interface CollectionChartWidgetProps {
  period?: PeriodOption;
}

export function CollectionChartWidget({ period = 'month' }: CollectionChartWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <DataView query={query} isEmpty={() => false}>
      {(data) => (
        <Suspense fallback={<Card className="min-h-[340px] p-5"><Skeleton className="h-full w-full" /></Card>}>
          <DashboardCharts collectionChart={data?.collectionChart ?? []} period={period} />
        </Suspense>
      )}
    </DataView>
  );
}

